import React, { memo } from 'react';

import { useTranslation } from 'react-i18next';

import { useFirstStep } from './useFirstStep';
import { Input } from '../../../components/newUI/Input/Input';
import { Select } from '../../../components/newUI/Select/Select';
import cls from '../AddProject.module.css';
import { IForm } from '../types/form.interface';
import { IFormError } from '../types/formError.interface';

interface FirstStepProps {
    classes?: string;
    onLoaderChange: (value: boolean) => void;
    onFormChange: (name: string, value: string) => void;
    form: IForm;
    formErrors: IFormError;
}

export const FirstStep = memo(
    ({ classes, onLoaderChange, onFormChange, form, formErrors }: FirstStepProps) => {
        const { t } = useTranslation();
        const { optionsList, selectedSelect, onChangeSelect } = useFirstStep(
            onLoaderChange,
            onFormChange
        );
        const { projectNameError } = formErrors;
        const { projectName, categoryName } = form;

        return (
            <div className={cls.CreateProject}>
                <Input
                    label={t('FirstStep.return.Input.label.projectName')}
                    inputName="projectName"
                    onChange={onFormChange}
                    value={projectName}
                    maxLength={255}
                    error={projectNameError}
                />
                <Select
                    isSmartPosition
                    title={t('FirstStep.return.Select.title')}
                    options={optionsList}
                    selected={selectedSelect}
                    onChange={onChangeSelect}
                    classes={cls.Select}
                    notAbsolute
                    widthClasses={cls.optionWidth}
                    colorClasses={cls.hiddenText}
                    fullArrow
                />
                {selectedSelect?.value === 'addCategory' && (
                    <Input
                        label={t('FirstStep.return.Input.label.categoryName')}
                        inputName="categoryName"
                        onChange={onFormChange}
                        value={categoryName}
                        placeholder={t('FirstStep.return.Input.placeholder')}
                    />
                )}
            </div>
        );
    }
);
